﻿import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";

import classes from "../maintainers.module.scss";

import { ReactComponent as PencilSvg } from "@/assets/images/desktop/editar.svg";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";

const IncidentsTableBody = ({ handleDelete, group, setGroup }) => {
	const navigate = useNavigate();

	const { dealers } = useSelector((state) => state.maintainers_dealers);

	const selectDealer = (dealer) => {
		let newDealers = [...group];
		if (!newDealers.find((p) => Number(p.dealer_id) === Number(dealer.dealer_id))) {
			newDealers.push(dealer);
		} else {
			newDealers = newDealers.filter((p) => Number(p.dealer_id) !== Number(dealer.dealer_id));
		}

		setGroup(newDealers);
	};

	return (
		<tbody>
			{dealers &&
				dealers.map((item, i) => {
					let checked = false;
					if (group.find((p) => Number(p.dealer_id) === Number(item.dealer_id))) {
						checked = true;
					}

					return (
						<tr className={`${classes.table_tr}`} key={i}>
							<td className={`${classes.table_td} ${classes.first_td}`}>
								<div className={`${classes.table_div} ${classes.first_div} ${classes.center}`}>
									<Form.Check type="checkbox" checked={checked} onChange={(_e) => selectDealer(item)} />
								</div>
							</td>

							<td className={`${classes.table_td} `}>
								<div className={`${classes.table_div}`}>{item.rut_dealer}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>{item.common_name}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>{item.name}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.last_div}`}>
									<PencilSvg className={classes.icon} onClick={() => navigate("/mantenedores/distribuidores/editar/" + item.dealer_id)} />
									<RemoveSvg className={classes.icon} onClick={() => handleDelete(item)} />
								</div>
							</td>
						</tr>
					);
				})}
		</tbody>
	);
};

export default IncidentsTableBody;
